var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',{staticClass:"mt-0",staticStyle:{"max-height":"34px","padding-top":"16px"},attrs:{"label":_vm.label},on:{"change":function($event){return _vm.$emit('change')}},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }